import { FieldNumberInput, FieldTimeInput } from '@/components/form/fields';
import { DatePickerInput } from '@/domain/mitarbeiter/shared/components/form/fieldComponents/DatePickerInput';
import { HoursInput } from '@/domain/mitarbeiter/shared/components/form/fieldComponents/HoursInput';
import { MoneyInput } from '@/domain/mitarbeiter/shared/components/form/fieldComponents/MoneyInput';
import { TextAreaInput } from '@/domain/mitarbeiter/shared/components/form/fieldComponents/TextAreaInput';
import { TextInput } from '@/domain/mitarbeiter/shared/components/form/fieldComponents/TextInput';
import { SubmitButton } from '@/domain/mitarbeiter/shared/components/form/formComponents/SubmitButton';
import { createFormHook, createFormHookContexts } from '@tanstack/react-form';

export const { fieldContext, formContext, useFieldContext, useFormContext } =
  createFormHookContexts();

export const { useAppForm: useMitarbeiterAppForm } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    TextInput: TextInput,
    NumberInput: FieldNumberInput,
    TextAreaInput: TextAreaInput,
    TimeInput: FieldTimeInput,
    HoursInput: HoursInput,
    DatePickerInput: DatePickerInput,
    MoneyInput: MoneyInput,
  },
  formComponents: { SubmitButton: SubmitButton },
});
